// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g-root .chartkit .chartkit-ymap .chartkit-map-ground-pane {
  filter: var(--dl-filter-ymap-background);
}
.g-root .chartkit .chartkit-ymap [class*=map-bg] {
  background: var(--dl-color-ymap-background);
}
.g-root .chartkit .chartkit-ymap [class*=zoom__plus], .g-root .chartkit .chartkit-ymap [class*=zoom__minus], .g-root .chartkit .chartkit-ymap [class*=zoom__runner] {
  background-color: var(--g-color-base-background);
}
.g-root .chartkit .chartkit-ymap [class*=zoom__icon] {
  filter: var(--dl-filter-zoom-control);
}

.g-root .chartkit .chartkit-ymap-legend .chartkit-ymap-legend-layer__color-preview_default-heatmap {
  filter: var(--dl-filter-ymap-heatmap);
}

.chartkit-theme_common {
  --ck-loader-active: var(--g-color-base-brand);
  --ck-veil-background: var(--g-color-sfx-fade);
  --highcarts-navigator-border: var(--g-color-line-generic);
  --highcarts-navigator-track: var(--g-color-base-generic);
  --highcarts-navigator-body: var(--g-color-scroll-handle);
  --highcharts-series-border: var(--g-color-base-background);
  --highcharts-grid-line: var(--g-color-line-generic);
  --highcharts-axis-line: var(--g-color-line-generic);
  --highcharts-tick: var(--g-color-line-generic);
  --highcharts-title: var(--g-color-text-primary);
  --highcharts-axis-labels: var(--g-color-text-secondary);
  --highcharts-data-labels: var(--g-color-text-complementary);
  --highcharts-plot-line-label: var(--g-color-text-complementary);
  --highcharts-legend-item: var(--g-color-text-secondary);
  --highcharts-legend-item-hover: var(--g-color-text-primary);
  --highcharts-legend-item-hidden: var(--g-color-text-hint);
  --highcharts-floating-bg: var(--g-color-infographics-tooltip-bg);
  --highcharts-tooltip-text: var(--g-color-text-primary);
  --highcharts-tooltip-bg: var(--highcharts-floating-bg);
  --highcharts-tooltip-alternate-bg: var(--g-color-base-generic);
  --highcharts-tooltip-text-complementary: var(--g-color-text-complementary);
  --highcharts-holiday-band: var(--g-color-base-generic);
  --data-table-color-base: var(--g-color-base-background);
  --data-table-color-stripe: var(--g-color-base-generic);
  --data-table-border-color: var(--g-color-line-generic-solid);
  --data-table-color-hover-area: var(--g-color-base-simple-hover);
  --data-table-color-footer-area: var(--data-table-color-base);
  --dl-table-border-color: var(--g-color-line-generic-solid);
  --dl-table-header-bg-color: var(--g-color-base-background);
  --dl-table-body-bg-color: var(--g-color-base-background);
  --dl-table-no-data-bg-color: var(--g-color-base-generic);
  --dl-table-footer-bg-color: var(--g-color-base-generic);
}

.chartkit-scrollable-node {
  overflow: auto;
  max-height: 100%;
}
.chartkit-metric .chartkit-scrollable-node {
  max-height: none;
}

.chartkit {
  height: 100%;
  width: 100%;
}
.chartkit_mobile {
  --ck-split-pane-background: var(--dl-color-widget-background, var(--g-color-base-float));
}
.chartkit_mobile .chartkit-scrollable-node {
  max-height: 3000px;
}

.chartkit-graph .yfm,
.chartkit-tooltip .yfm {
  display: inline-block;
}
.chartkit-graph .yfm img,
.chartkit-tooltip .yfm img {
  max-width: unset;
}

.gcharts-tooltip .gcharts-tooltip__content-row {
  font-size: 13px;
}

.dl-chart-tooltip-content {
  font-size: 13px;
  padding: 0 14px;
}
.dl-chart-tooltip-content_mobile {
  padding: var(--g-spacing-3);
  font-size: 13px;
}
.dl-chart-tooltip-content__row {
  display: flex;
}
.dl-chart-tooltip-content__color {
  align-self: center;
  border-radius: 1px;
  display: inline-block;
  height: 6px;
  width: 12px;
}
.dl-chart-tooltip-content__block {
  display: flex;
  padding: 0 4px;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/ChartKit/theme.scss","webpack://./src/ui/libs/DatalensChartkit/ChartKit/ChartKit.scss"],"names":[],"mappings":"AA0DI;EACI,wCAAA;ACzDR;AD4DI;EACI,2CAAA;AC1DR;AD6DI;EAGI,gDAAA;AC7DR;ADgEI;EACI,qCAAA;AC9DR;;ADmEI;EACI,qCAAA;AChER;;AAbA;EDAI,6CAAA;EAGA,6CAAA;EAGA,yDAAA;EACA,wDAAA;EACA,wDAAA;EAGA,0DAAA;EAEA,mDAAA;EACA,mDAAA;EACA,8CAAA;EAEA,+CAAA;EACA,uDAAA;EACA,2DAAA;EACA,+DAAA;EAEA,uDAAA;EACA,2DAAA;EACA,yDAAA;EAGA,gEAAA;EAGA,sDAAA;EACA,sDAAA;EACA,8DAAA;EACA,0EAAA;EAGA,sDAAA;EAGA,uDAAA;EACA,sDAAA;EACA,4DAAA;EACA,+DAAA;EACA,4DAAA;EAGA,0DAAA;EACA,0DAAA;EACA,wDAAA;EACA,wDAAA;EACA,uDAAA;ACFJ;;AA5CA;EACI,cAAA;EACA,gBAAA;AA+CJ;AA7CI;EACI,gBAAA;AA+CR;;AA3CA;EACI,YAAA;EACA,WAAA;AA8CJ;AA5CI;EAOI,wFAAA;AAwCR;AA5CQ;EACI,kBAAA;AA8CZ;;AArCI;;EACI,qBAAA;AAyCR;AAvCQ;;EACI,gBAAA;AA0CZ;;AApCI;EACI,eAAA;AAuCR;;AAnCA;EACI,eAAA;EACA,eAAA;AAsCJ;AApCI;EACI,2BAAA;EACA,eAAA;AAsCR;AAnCI;EACI,aAAA;AAqCR;AAlCI;EACI,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;AAoCR;AAjCI;EACI,aAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAmCR","sourcesContent":[null,".g-root .chartkit .chartkit-ymap .chartkit-map-ground-pane {\n  filter: var(--dl-filter-ymap-background);\n}\n.g-root .chartkit .chartkit-ymap [class*=map-bg] {\n  background: var(--dl-color-ymap-background);\n}\n.g-root .chartkit .chartkit-ymap [class*=zoom__plus], .g-root .chartkit .chartkit-ymap [class*=zoom__minus], .g-root .chartkit .chartkit-ymap [class*=zoom__runner] {\n  background-color: var(--g-color-base-background);\n}\n.g-root .chartkit .chartkit-ymap [class*=zoom__icon] {\n  filter: var(--dl-filter-zoom-control);\n}\n\n.g-root .chartkit .chartkit-ymap-legend .chartkit-ymap-legend-layer__color-preview_default-heatmap {\n  filter: var(--dl-filter-ymap-heatmap);\n}\n\n.chartkit-theme_common {\n  --ck-loader-active: var(--g-color-base-brand);\n  --ck-veil-background: var(--g-color-sfx-fade);\n  --highcarts-navigator-border: var(--g-color-line-generic);\n  --highcarts-navigator-track: var(--g-color-base-generic);\n  --highcarts-navigator-body: var(--g-color-scroll-handle);\n  --highcharts-series-border: var(--g-color-base-background);\n  --highcharts-grid-line: var(--g-color-line-generic);\n  --highcharts-axis-line: var(--g-color-line-generic);\n  --highcharts-tick: var(--g-color-line-generic);\n  --highcharts-title: var(--g-color-text-primary);\n  --highcharts-axis-labels: var(--g-color-text-secondary);\n  --highcharts-data-labels: var(--g-color-text-complementary);\n  --highcharts-plot-line-label: var(--g-color-text-complementary);\n  --highcharts-legend-item: var(--g-color-text-secondary);\n  --highcharts-legend-item-hover: var(--g-color-text-primary);\n  --highcharts-legend-item-hidden: var(--g-color-text-hint);\n  --highcharts-floating-bg: var(--g-color-infographics-tooltip-bg);\n  --highcharts-tooltip-text: var(--g-color-text-primary);\n  --highcharts-tooltip-bg: var(--highcharts-floating-bg);\n  --highcharts-tooltip-alternate-bg: var(--g-color-base-generic);\n  --highcharts-tooltip-text-complementary: var(--g-color-text-complementary);\n  --highcharts-holiday-band: var(--g-color-base-generic);\n  --data-table-color-base: var(--g-color-base-background);\n  --data-table-color-stripe: var(--g-color-base-generic);\n  --data-table-border-color: var(--g-color-line-generic-solid);\n  --data-table-color-hover-area: var(--g-color-base-simple-hover);\n  --data-table-color-footer-area: var(--data-table-color-base);\n  --dl-table-border-color: var(--g-color-line-generic-solid);\n  --dl-table-header-bg-color: var(--g-color-base-background);\n  --dl-table-body-bg-color: var(--g-color-base-background);\n  --dl-table-no-data-bg-color: var(--g-color-base-generic);\n  --dl-table-footer-bg-color: var(--g-color-base-generic);\n}\n\n.chartkit-scrollable-node {\n  overflow: auto;\n  max-height: 100%;\n}\n.chartkit-metric .chartkit-scrollable-node {\n  max-height: none;\n}\n\n.chartkit {\n  height: 100%;\n  width: 100%;\n}\n.chartkit_mobile {\n  --ck-split-pane-background: var(--dl-color-widget-background, var(--g-color-base-float));\n}\n.chartkit_mobile .chartkit-scrollable-node {\n  max-height: 3000px;\n}\n\n.chartkit-graph .yfm,\n.chartkit-tooltip .yfm {\n  display: inline-block;\n}\n.chartkit-graph .yfm img,\n.chartkit-tooltip .yfm img {\n  max-width: unset;\n}\n\n.gcharts-tooltip .gcharts-tooltip__content-row {\n  font-size: 13px;\n}\n\n.dl-chart-tooltip-content {\n  font-size: 13px;\n  padding: 0 14px;\n}\n.dl-chart-tooltip-content_mobile {\n  padding: var(--g-spacing-3);\n  font-size: 13px;\n}\n.dl-chart-tooltip-content__row {\n  display: flex;\n}\n.dl-chart-tooltip-content__color {\n  align-self: center;\n  border-radius: 1px;\n  display: inline-block;\n  height: 6px;\n  width: 12px;\n}\n.dl-chart-tooltip-content__block {\n  display: flex;\n  padding: 0 4px;\n  max-width: 400px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
